import styled from 'styled-components'

const StyledContainer = styled.div`
    width: 100%;
    height: ${({ customHeight }) => customHeight || '100%'};
    max-width: 375px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 24px 24px;
    & > * {
        width: 100%;
    } 
`;

const AppContainer = ({ customHeight, children }) => (
    <StyledContainer customHeight={customHeight}>
        {children}
    </StyledContainer>
);

export default AppContainer;